// extracted by mini-css-extract-plugin
module.exports = {"container":"cornerQuantity_container__IPmuP","cornerQuantity":"cornerQuantity_cornerQuantity__or_QR","menu":"cornerQuantity_menu__QI8VP"};